<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="editForm" size="mini" :label-width="'130px'" class="form-horizontal detail-form paddingTopDetail employeeEditDetail" >
      <el-form-item prop="name" class="is-required" label="姓名：" >
        <el-input v-model="formData.name" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item prop="phone" class="is-required" label="联系电话：" >
        <el-input v-model="formData.phone" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item  prop="staffType" label="人员类型："  >
        <el-select v-model="formData.staffType" filterable placeholder="请选择" >
          <el-option v-for="item in selOptions.staffType" :key="item.name" :label="item.value" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="certType" class="is-required" label="证件种类：" >
        <el-select v-model="formData.certType" filterable placeholder="请选择" >
          <el-option v-for="item in selOptions.certType" :key="item.name" :label="item.value" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="certCode" class="is-required" label="证件号码：" >
        <el-input v-model="formData.certCode" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item  prop="company" label="工作单位："  >
        <template v-if="shopDataList">
          <el-select v-model="formData.company" @change="onCompanyChange">
            <el-option
              v-for="(item, i) of shopDataList"
              :key="i"
              :label="item.storeName"
              :value="item.storeName"
            ></el-option>
          </el-select>
        </template>
        <template v-else>
          <el-input v-model="formData.company" placeholder="请输入" disabled></el-input>
        </template>
      </el-form-item>
      <el-form-item  prop="socialCreditCode" label="社会信用代码："  >
        <el-input v-model="formData.socialCreditCode" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item  prop="hireDate" label="入职日期：" >
        <el-date-picker
          v-model="formData.hireDate"
          type="date"
          placeholder="选择日期"
          style="width: 100%;"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item  prop="leaveDate" label="离职日期：" >
        <el-date-picker
          v-model="formData.leaveDate"
          type="date"
          placeholder="选择日期"
          style="width: 100%;"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item  prop="companyAddress" label="工作地："  class="rowItem">
        <div class="flex-row">
          <AreaCascader
            v-model="formData.areaCode"
            :end-level="2"
          />
          <!-- <el-select v-model="formData.dwbgdzSfbm" filterable clearable placeholder="省" popper-class="edit-sel-popper" class="m-r-md" @change='selectedChange($event, "getCity",false)' >
            <el-option v-for="item in wyfdzSsxqdm_provinceDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
          <el-select v-model="formData.dwbgdzSbm" filterable clearable placeholder="市" class="m-r-md" popper-class="edit-sel-popper" @change='selectedChange($event, "getArea")' >
            <el-option v-for="item in wyfdzSsxqdm_cityDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
          <el-select v-model="formData.dwbgdzQbm" filterable clearable placeholder="区（县）" popper-class="edit-sel-popper" style="z-index: 8888 !important;">
            <el-option v-for="item in wyfdzSsxqdm_areaDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select> -->
        </div>
      </el-form-item>
      <el-form-item  prop="companyAddress" label="详细地址：">
        <el-input v-model="formData.companyAddress" placeholder="请输入"></el-input>
      </el-form-item>
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="primary-btn-g" icon="CircleCheck" @click="handleSave(0)" >保存</el-button>
        <el-button class="warning-btn-g" icon="CircleClose" @click="handleCancel">取消</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import formCheck from '@/components/common/formCheck'
  import AreaCascader from "@/components/common/areaCascader";
  export default {
    components: {RichText, AreaCascader},
    name: "publishDetailModel",
    mixins: [ formCheck],
      props:{
        selOptions: {
          type: Object,
          default:{certType:[],staffType:[]},
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ['name','certType','certCode','company','socialCreditCode','staffType','companyAddress','hireDate','leaveDate','wyfptdwbm' ,'djsj','dwbgdzSfbm','dwbgdzSbm','wyfdzSsxqdm','phone', 'areaCode'];
        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })
        let validateTel = (rule, value, callback) => {
          if (value.trim()!='' && !this.checkTelNum(value)) {
            callback(new Error('格式错误'));
          } else {
            callback();
          }
        };
        return{
          isValid:true,
          activeNames: ['1','2','3','4','5','6','7'],
          showType:'',
          saveLoading:false,
          detailKeys:detailKeys,

          rules:{
            /*'name','certType','certCode','company','socialCreditCode','staffType','companyAddress','hireDate','wyfptdwbm' ,'djsj','dwbgdzSfbm','dwbgdzSbm','wyfdzSsxqdm'*/
            name: [{ required: true, message: '请输入', trigger: 'blur' },],
            certType: [{ required: true, message: '请输入', trigger: 'blur' },],
            certCode: [{ required: true, message: '请输入', trigger: 'blur' },],
            company: [{ required: true, message: '请输入', trigger: 'blur' },],
            socialCreditCode: [{ required: true, message: '请输入', trigger: 'blur' },],
            staffType: [{ required: true, message: '请输入', trigger: 'blur' },],
            companyAddress: [{ required: true, message: '请输入', trigger: 'blur' },],
            hireDate: [{ required: true, message: '请输入', trigger: 'blur' },],
            wyfptdwbm: [{ required: true, message: '请输入', trigger: 'blur' },],
            djsj: [{ required: true, message: '请输入', trigger: 'blur' },],
            wyfdzSsxqdm: [{ required: true, message: '请选择', trigger: 'blur' },],
            phone:[{ validator: validateTel, trigger: 'change' }]

          },
          wyfdzSsxqdm_provinceDicts:[],
          wyfdzSsxqdm_cityDicts:[],
          wyfdzSsxqdm_areaDicts:[],
          areaCodes:{},
          formData:formData,
          shopDataList: null,
        }
    },
    created(){
      this.initSelData()
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.$nextTick(()=>{
            this.$refs.editForm.resetFields()
            this.initFormData()
          })

        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      // 获取门店列表
      getShops() {
        this.fetchData({
          url: 'SHOP.GET_LIST',
          method: 'get',
          params: { pageSize: 100, pageNumber: 1 },
        }).then(res => {
          console.log(res);
          this.shopDataList = res && res.data || [];
        })
      },
      onCompanyChange(companyName){
        const company = this.shopDataList.find(e => e.storeName == companyName);
        this.formData.socialCreditCode = company.storeCode;
      },
      initFormData() {
        if(this.detailType=='add'){
          this.detailKeys.map((key)=>{
            if(key == "company"){
              const manager = JSON.parse(localStorage.getItem('manager'));
              if(manager && manager.companyName && manager.companyCreditCode){
                this.formData.company = manager.companyName;
                this.formData.socialCreditCode = manager.companyCreditCode;
              }else{
                this.getShops();
                this.formData[key] = '';
              }
            }else if(key != 'socialCreditCode'){
              this.formData[key] = '';
            }
          })
          this.formData.wyfptdwbm = 'aaaaa' //平台编码不可删除
          // this.formData.djsj = moment().format('YYYY-MM-DD HH:mm:ss')
          /*jjlxdm:[],fddbrGjdm:[],fddbrCyzjdm:[],hylbdm:[]*/
          this.formData.certType = this.selOptions.certType[0] ? this.selOptions.certType[0].name : ''
          this.formData.staffType = '01'
        }
        if(this.detailType=='edit'){
          this.detailKeys.map((key)=>{
            this.formData[key] = this.detailData[key] ? this.detailData[key]:''
          })
          this.formData.wyfptdwbm = this.detailData['wyfptdwbm'] //平台编码不可删除

          /* this.formData.phone = '18623562561'
           this.formData.fddbrLxdh = '18623562562'
           this.formData.fddbrZjhm = '440302185601025888'
           this.formData.lxrLxdh = '18623562563'
           this.formData.lxrGmsfhm = '440302185601025889'*/

          //省市区域
          // getCity
          let p1 = this.fetchData({
            url:'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.dwbgdzSfbm }
          })
          //getArea
          let p2 = this.fetchData({
            url:'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.dwbgdzSbm }
          })

          Promise.all([p1, p2]).then(([res1, res2]) => {
            this.handleAreaChange(res1,"getCity",true)
            this.handleAreaChange(res2,"getArea",true)
          }).catch((err)=>{
            console.log(err,'------')
          }).finally(()=>{
          })

        }
      },
      initSelData() {
        //区域
        let sp1 = this.fetchData({
          url: 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE',
          params: {
            parentCode: '0'
          },
          method: 'get'
        })
        Promise.all([sp1]).then(([rest1]) => {
          this.$nextTick(()=> {
            let tempArr = []
            console.log(rest1);
            rest1 && rest1.forEach(re => {
              if (re.areaName) {
                tempArr.push({
                  value: re.areaCode,
                  label: re.areaName,
                  areaCode: re.areaCode,
                  areaName: re.areaName
                })
              }
            })
            this['wyfdzSsxqdm_provinceDicts'] = [...tempArr]
          })

        }).catch((err)=>{
          console.log(err,'-----------')
        }).finally(()=>{
          this.$nextTick(()=>{
            this.saveLoading = false
          })
        })
      },
      handleAreaChange(res,evt,flag){
        let tempArr = []
        res.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName,
            })
          }
        });
        if (evt === 'getCity') {
          this.wyfdzSsxqdm_cityDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.cityCode = '';
          this.formData.areaCode = '';
          this.formData.policeStaCode = '';
        }
        if (evt === 'getArea') {
          this.wyfdzSsxqdm_areaDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.areaCode = '';
          this.formData.policeStaCode = '';
        }
      },
      /*
      * {"frhqtzztyshxydm":"964561622564512634","company":"天网互联","dwjymc":"天网互联","dwywsx":"tw11","jjlxdm":130,"hylbdm":6110,"kyrq":"2021-04-06","zczb":100,"jyfwzy":"","jyfwjy":"","sbrq":"2021-04-06 11:00:20","gxsj":"2021-04-06 11:00:20","yyzzyxqQsrq":"2021-04-06 00:00:00","yyzzyxqJzrq":"2021-04-30 00:00:00","phone":"18623562561","dwbgdzSsxqdm":"广东省 深圳市 南山区","dwbgdzQhnxxdz":"深圳市南山区桃源街道平山一路新视艺创客公园A栋3楼05","dwzcdzSsxqdm":"广东省 深圳市 盐田区","dwzcdzQhnxxdz":"深圳市南山区大学城地铁站旁边","wz":"","fddbrXm":"胡雨洋","fddbrGjdm":"124","fddbrCyzjdm":"111","fddbrZjhm":"440302185601025888","fddbrWwx":"","fddbrWwm":"","fddbrLxdh":"18623562562","lxrXm":"胡雨洋","lxrLxdh":"18623562563","lxrGmsfhm":"440302185601025889","id":94}*/
      selectedChange(codeValue, evt ,flag = false) {
        let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
        // let code = codeValue.substr(-6)
        let code = codeValue;
        let params = { parentCode: code }
        this.fetchData({
          url,
          method: 'get',
          params
        }).then(res => {
          let tempArr = []
          console.log(res);
          res.forEach(re => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                areaCode: re.areaCode,
                areaName: re.areaName,
              })
            }

          });
          if (evt === 'getCity') {
            this.wyfdzSsxqdm_cityDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzSbm = '';
            this.formData.companyAddress = '';
          }
          if (evt === 'getArea') {
            this.wyfdzSsxqdm_areaDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.companyAddress = '';
          }
        }).catch(err => {
          this.error = err
        })
      },
      //保存与发布
      //保存与发布
      handleSave(type){
        this.saveLoading = true
        this.trimFormData()
        // console.log(this.formData.leaveDate,moment(this.formData.hireDate),moment(this.formData.leaveDate))
        this.$refs['editForm'].validate((valid) => {
          if (valid && this.isValid) {

            if(this.formData.leaveDate && this.formData.leaveDate <= this.formData.hireDate){
              this.$message.error('离职日期必须大于入职日期！')
              this.saveLoading = false
              return false;
            }else{
              this.doSave(type)
            }
          } else {
           // this.$message.error('输入不合法！')
            this.saveLoading = false
            return false;
          }
        });
      },
      doSave(type){

        let url = 'CLEAN.CLEANER.POST_SAVE'
        let paramData = {...this.formData}
        let areaName = ''
        this.wyfdzSsxqdm_provinceDicts.map((item)=>{
          if(item.areaCode==this.formData.dwbgdzSfbm){
            areaName = item.areaName
          }
        })
        this.wyfdzSsxqdm_cityDicts.map((item)=>{
          if(item.areaCode==this.formData.dwbgdzSbm){
            areaName += ' ' + item.areaName
          }
        })
        this.wyfdzSsxqdm_areaDicts.map((item)=>{
          if(item.areaCode==this.formData.companyAddress){
            areaName += ' ' + item.areaName
          }
        })
        paramData.wyfdzSsxqdm = areaName
        if(this.detailType=='edit'){
          paramData.id = this.detailData.id
        }
        paramData.hireDate = moment(this.formData.hireDate).format('YYYY-MM-DD')
        if(this.formData.leaveDate)
          paramData.leaveDate = moment(this.formData.leaveDate).format('YYYY-MM-DD')
        let params = {
          id: paramData.id,
          areaCode: paramData.areaCode[2],
          certType: paramData.certType,
          certCode: paramData.certCode,
          company: paramData.company,
          companyAddress: paramData.companyAddress,
          name: paramData.name,
          phone: paramData.phone,
          staffType: paramData.staffType,
          hireDate: paramData.hireDate,
          leaveDate: paramData.leaveDate,
          socialCreditCode: paramData.socialCreditCode,
        };

        this.fetchData({
          url,
          method: 'post',
          params,
          timeout:0,
          isLoading:false,
          flag:true,
          headers: { "Content-Type": "application/json" },
        }).then((res)=>{
          console.log(res);
          if(res.code==200){
            this.$message.success('操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error('操作失败！')
          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
    },
  }
</script>

<style lang="less" scoped>
  .employeeEditDetail{
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 90% !important;
  }
  .employeeEditDetail .el-form-item{
    width: 50% !important;
    .el-select{
      width: 100%;
    }
  }
  .employeeEditDetail .el-form-item.rowItem {
    width: 100% !important;
  }
  .employeeEditDetail .detailContent{
    padding: 0px;
  }
  .sentContent{
    margin: 20px;
    padding: 10px;
    border: 1px solid rgba(38, 118, 165, 1) ;
  }
  .sentContentTitle{
    text-align: center;
  }


</style>
<style lang="less" >
  .employeeEditDetail .w-e-text-container{
    border:1px solid #2676a5 !important;
  }
</style>

